import React from "react";
import { useProductOutput } from "stores/product";
import { AcousticResults } from "./components/SingleSelectionTab/components/AcousticResults";
import { TechnicalResults } from "./components/SingleSelectionTab/components/TechnicalResults";
import { ProductMediaTabs } from "../Media/ProductMediaTabs";

export const TechnicalPropertiesSimpleView = () => {
  const productOutput = useProductOutput();

  const hasAcousticOutputs =
    productOutput?.product?.outputsAcoustic?.length !== undefined &&
    productOutput?.product?.outputsAcoustic?.length > 0;

  const hasOutputs =
    productOutput?.product?.outputs?.length !== undefined &&
    productOutput?.product?.outputs?.length > 0;

  return (
    <div className="d-flex flex-wrap gap-4 mb-4 w-100">
      <ProductMediaTabs />
      {hasOutputs && <TechnicalResults />}
      {hasAcousticOutputs && <AcousticResults />}
    </div>
  );
};
